const actionTypes = {
  TOGGLE_REVERSE_DRAWER_VISIBLE: Symbol('TOGGLE_REVERSE_DRAWER_VISIBLE'),
  FETCH_REVERSE_AMOUNT: Symbol('FETCH_REVERSE_AMOUNT'),
  RESET_REVERSE_AMOUNT: Symbol('RESET_REVERSE_AMOUNT'),
};

export default actionTypes;
